
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaa2b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaa2b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7xovm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ce9f9ca6d03c71$export$2e2bcd8739ae039);

var $7L4n8 = parcelRequire("7L4n8");
class $57ce9f9ca6d03c71$var$I18n {
    constructor(){
        const savedLang = localStorage.getItem('ily-language');
        const langCode = savedLang || 'es';
        this.currentLang = langCode;
        this.translations = (0, $7L4n8.translations)[this.currentLang] || (0, $7L4n8.translations).es;
    }
    /**
     * Sets current language and updates page
     * @param {string} lang - Language code ('es' or 'en')
     */ setLanguage(lang) {
        if ((0, $7L4n8.translations)[lang]) {
            this.currentLang = lang;
            this.translations = (0, $7L4n8.translations)[lang];
            localStorage.setItem('ily-language', lang);
            this.updatePage();
        }
    }
    /**
     * @returns {string} Current language code
     */ getLanguage() {
        return this.currentLang;
    }
    /**
     * Gets translated text for key with optional parameter replacement
     * @param {string} key - Translation key
     * @param {Object} params - Parameters to replace in format {name: value}
     * @returns {string} Translated text
     */ t(key, params = {}) {
        let text = this.translations[key] || key;
        if (params && typeof text === 'string') Object.keys(params).forEach((param)=>{
            text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), params[param]);
        });
        return text;
    }
    /**
     * Updates all elements with data-i18n attribute with current language translations
     */ updatePage() {
        document.querySelectorAll('[data-i18n]').forEach((element)=>{
            const key = element.getAttribute('data-i18n');
            const text = this.t(key);
            if (element.tagName === 'INPUT' && element.type !== 'submit' && element.type !== 'button') {
                if (element.hasAttribute('placeholder')) element.placeholder = text;
                else element.value = text;
            } else if (element.tagName === 'SELECT') {
                // For select elements, update the label if it exists, not the select itself
                const label = element.closest('.form-group')?.querySelector('label');
                label && (label.getAttribute('for'), element.id);
            } else if (element.tagName === 'OPTION') element.textContent = text;
            else if (element.tagName === 'IMG' && element.hasAttribute('alt')) element.alt = text;
            else element.innerHTML = text;
        });
        const titleKey = document.querySelector('title')?.getAttribute('data-i18n');
        if (titleKey) document.title = this.t(titleKey);
    }
}
var $57ce9f9ca6d03c71$export$2e2bcd8739ae039 = new $57ce9f9ca6d03c71$var$I18n();

});
parcelRegister("7L4n8", function(module, exports) {

$parcel$export(module.exports, "translations", () => $5a605067442d0235$export$150b732325d14d04);
const $5a605067442d0235$export$150b732325d14d04 = {
    en: {
        // Common
        loading: "Loading packages...",
        searchPlaceholder: "Search by country names",
        // Title Section
        logo: "I love J1",
        subtitle: "Where are you traveling?",
        subtitleDescription: "Add the countries you're traveling to and view the plans that best fit your trip.",
        // Sections
        myEsims: "My eSIMs",
        availablePlans: "Available Plans",
        favoritePlans: "Favorite Plans",
        selectDuration: "Select Duration",
        selectDataPackage: "Select Data Package",
        esimFeatures: "Benefits of an eSIM",
        faqTitle: "Frequently Asked Questions",
        // eSIM Info
        esimInfoTitle: "What is an eSIM?",
        esimInfoText: "An eSIM is a digital SIM that installs on your phone in seconds and gives you access to a data package without having to change chips or do paperwork. When you arrive in the country, it activates automatically and connects you to the local network without roaming charges, so you can use all your apps as usual.",
        esimInfoNote: "Just keep in mind that not all phones accept eSIM and you won't be able to receive or make traditional calls (WhatsApp works perfectly).",
        // Features
        feature1Title: "Activation in 1 minute",
        feature1Description: "Install the eSIM by scanning a QR code or tapping a button. No paperwork or searching for sales points needed.",
        feature2Title: "Connected from landing",
        feature2Description: "The plan activates as soon as you arrive in the country and you already have internet to locate yourself, communicate, and move around without delay.",
        feature3Title: "No need to change your physical chip",
        feature3Description: "You can use your usual chip and keep your WhatsApp number without modifying anything on your phone.",
        feature4Title: "Super low costs",
        feature4Description: "Affordable plans, no contracts or hidden fees. You only pay for what you need during your trip.",
        feature5Title: "5G speed where available",
        feature5Description: "Fast and stable connection to use maps, social networks, video calls, and any app you need.",
        feature6Title: "Instant top-ups",
        feature6Description: "If your plan runs out, you renew it in seconds from the web. No calls or waiting.",
        // Cart
        cart: "Cart",
        cartEmpty: "Your cart is empty",
        clearCart: "Clear Cart",
        total: "Total",
        buy: "Pay",
        price: "Price",
        processingFeeIncluded: "Processing Fee (included)",
        quantity: "Quantity",
        subtotal: "Subtotal",
        // Package Details
        packageDetails: "Package Details",
        data: "Data",
        dataUsage: "Data Usage",
        duration: "Duration",
        status: "Status",
        speed: "Speed",
        sms: "SMS",
        dataType: "Data Type",
        activeType: "Active Type",
        operators: "Operators",
        supportTopUp: "Allows Top Up",
        countriesIncluded: "Countries Included",
        suspend: "Pause",
        unsuspend: "Activate",
        topup: "Top Up",
        esimSuspended: "eSIM paused successfully",
        esimUnsuspended: "eSIM activated successfully",
        suspendFailed: "The eSIM does not allow to be paused",
        unsuspendFailed: "The eSIM does not allow to be activated",
        noTopupPlansAvailable: "No top-up plans available",
        topupPlans: "Top-up Plans",
        errorLoadingTopupPlans: "Error loading top-up plans",
        packageCodeNotFound: "Package code not found",
        storeNotAvailable: "Store not available",
        viewDetails: "ViewDetails",
        // Navigation
        checkCompatibility: "Check Compatibility",
        installation: "How to Install",
        method1Title: "Method 1: Scan QR Code or use the installation button on iOS",
        method1Step1: "Scan the QR Code using your phone's camera or use the installation button on iOS.",
        method1Step2: "Click \"Cellular Plan\" to install.",
        roamingNotice: "Enable roaming for the eSIM. It will not generate any additional charges.",
        method2Title: "Method 2: Enter Activation Code Manually",
        method2Step1: "Go to Settings > Cellular > Add eSIM > Enter Details Manually.",
        method2Step2: "Enter the \"SM-DP+ Address\" and \"Activation Code\", then tap \"Next\".",
        deviceSearchPlaceholder: "Search for your device",
        deviceCompatible: "Compatible",
        deviceNotCompatible: "Not Compatible",
        deviceFound: "Device found",
        deviceNotFound: "Device not found",
        searchYourDevice: "Search for your device to verify eSIM compatibility",
        compatibilityMethod1Title: "Method 1: Use the dialer code",
        compatibilityMethod1Step1: "Open your phone's dialer and type *#06#.",
        compatibilityMethod1Step2: "A screen will display your phone's IMEI.",
        compatibilityMethod1Step3: "If it also shows an \"EID\", your phone supports eSIM.",
        compatibilityMethod2Title: "Method 2: Check through settings",
        compatibilityMethod2Step1: "Go to your phone's settings.",
        compatibilityMethod2Step2: "For iOS: Settings > Mobile Data/Cellular",
        compatibilityMethod2Step3: "For Android: Settings > Connections/SIM card Manager",
        compatibilityMethod2Step4: "Look for an \"Add eSIM\" or \"eSIM\" option.",
        compatibilityMethod3Title: "Method 3: Search in our list",
        // Auth
        account: "Account",
        login: "Login",
        register: "Register",
        logout: "Exit",
        createAccount: "Create Account",
        emailAddress: "Email Address",
        password: "Password",
        firstName: "First Name",
        lastName: "Last Name",
        fullName: "Full Name",
        country: "Country",
        language: "Language",
        spanish: "Spanish",
        english: "English",
        passwordMinLength: "Must be at least 6 characters",
        hello: "Hello, {name}!",
        profile: "Profile",
        editProfile: "Edit Profile",
        saveChanges: "Save Changes",
        allRightsReserved: "All rights reserved",
        needHelpContact: "If you need help, contact us at",
        emailCopied: "Email copied to clipboard",
        newPassword: "New Password (optional)",
        profileUpdated: "Profile updated successfully!",
        profileUpdateFailed: "Failed to update profile. Please try again.",
        emailNotVerified: "Your email is not verified. Make sure it's correct and verify it by clicking the link we sent you so you don't lose access to your eSIM information.",
        resendVerificationEmail: "Resend Email",
        verificationEmailResent: "Verification email sent successfully!",
        verificationEmailResendFailed: "Failed to resend verification email. Please try again.",
        verificationCode: "Verification Code",
        sendCode: "Send Code",
        verifyCode: "Verify Code",
        codeSent: "Verification code sent successfully!",
        codeSentMessage: "A code has been sent to your email address",
        emailDetailsMessage: "We will send your eSIM details to this email. Make sure it's correct.",
        codeSendFailed: "Failed to send verification code. Please try again.",
        codeVerificationFailed: "Code verification failed. Please check the code and try again.",
        codeVerified: "Code verified successfully!",
        invalidCode: "Invalid code. Please enter a 6-digit code.",
        nameRequired: "Full name is required.",
        emailRequired: "Email address is required.",
        changeEmail: "Change email",
        // Messages
        emailVerified: "Email verified successfully!",
        emailVerificationFailed: "Email verification failed. The link may have expired.",
        loginSuccessful: "Login successful!",
        loginFailed: "Login failed. Please check your credentials.",
        passwordTooShort: "Password must be at least 6 characters",
        registrationSuccessful: "Registration successful!",
        registrationFailed: "Registration failed. Please try again.",
        paymentCanceled: "Payment was canceled. Your cart has been preserved.",
        paymentSuccessful: "Payment successful! Thank you for your purchase. We sent you an email with all the details of your purchase.",
        errorProcessingPayment: "Error processing payment. Please try again.",
        termsAndConditions: "Terms and Conditions",
        pricesInUSD: "Prices in US Dollars (USD)",
        noPlansFound: "No plans found for selected countries",
        noEsims: "No eSIMs found",
        loadingEsims: "Loading your eSIMs",
        usageUpdated: "Usage updated successfully",
        install: "Install",
        qr: "QR",
        iosInstall: "iOS <small>(17.4+)</small>",
        androidInstall: "Android <small>(10+)</small>",
        manual: "Manual",
        scanQrCode: "Scan it with your phone",
        smdpAddress: "SM-DP+ Address",
        activationCode: "Activation Code",
        apn: "APN",
        pin: "PIN",
        puk: "PUK",
        usageDelayNote: "with 1-hour delay",
        // Package info
        plan: "plan",
        plans: "plans",
        package: "package",
        packages: "packages",
        day: "day",
        days: "days",
        // Status
        included: "Included",
        notIncluded: "Not included",
        yes: "Yes",
        no: "No",
        // Data types
        dataInTotal: "Data in Total",
        dailyLimitSpeedReduced: "Daily Limit (Speed Reduced)",
        dailyLimitServiceCutoff: "Daily Limit (Service Cut-off)",
        dailyUnlimited: "Daily Unlimited",
        // Active types
        firstInstallation: "First installation",
        firstNetworkConnection: "First network connection",
        // Autocomplete
        country: "Country",
        region: "Region",
        global: "Global",
        // eSIM fields
        validity: "Validity",
        daysRemaining: "days remaining",
        dayRemaining: "day remaining",
        // eSIM Status translations
        GETTING_RESOURCE: "Getting Resource",
        GOT_RESOURCE: "Ready to Install",
        IN_USE: "In Use",
        USED_UP: "Used Up",
        UNUSED_EXPIRED: "Expired",
        USED_EXPIRED: "Expired",
        CANCEL: "Cancelled",
        SUSPENDED: "Suspended",
        REVOKE: "Revoked",
        RELEASED: "Ready to Install",
        DOWNLOAD: "Downloaded",
        INSTALLATION: "Installed",
        ENABLED: "Enabled",
        DISABLED: "Disabled",
        DELETED: "Deleted",
        // FAQ
        faqTitle: "Frequently Asked Questions",
        faq1Question: "Can plans be topped up on the same eSIM?",
        faq1Answer: "Users with an installed, active eSIM plan can perform a data top-up to extend both the eSIM validity and data amount. Users can top up an eSIM a maximum of 10 times.",
        faq1AnswerExample: "For example: if you have a 1GB 7 Day European eSIM plan, you could add another 1GB 7 day extension. This top-up would add to the existing plan, making it 2GB for 14 days. ( 1GB + 1GB = 2GB total. 7 Days + 7 Days = 14 Days total )",
        faq1AnswerNote: "Top-ups add validity and data together to give a new, updated total validity and data total after each top-up.",
        faq2Question: "Can a deleted eSIM be reinstalled?",
        faq2Answer: "eSIMs CAN be reinstalled from the same QR code they were installed with, in case they were deleted.",
        faq2AnswerNote: "Users can scan the same QR code used in the initial installation and re-add the eSIM profile in case of eSIM deletion. The reinstall process can only be done with the same device on which it was originally installed.",
        faq2AnswerWarning: "QR codes cannot be shared with another device after they have been deleted.",
        faq3Question: "When does the activation period or validity of a plan begin?",
        faq3Answer: "With the exception of some data plans, most data plans will only begin counting usage once you make your first connection to the local network. This will be indicated as \"Activation Type: First network connection\".",
        faq3AnswerNote: "When showing \"Activation Type: First installation\" the billing period will start immediately after installation and <u>activation</u> on your device. Therefore, we recommend activating the plan only after you have arrived at your destination.",
        faq4Question: "Does my eSIM come with a phone number or SMS?",
        faq4Answer: "Generally, eSIMs are data only. If an eSIM includes a phone number or SMS, it will be detailed in the plan. If there's no mention of minutes or SMS, it's a data-only eSIM.",
        faq5Question: "Can I use a physical SIM and my home number and eSIM together?",
        faq5Answer: "Yes, on dual SIM devices, you can use both a physical SIM with your home number and an eSIM. You can select which SIM to use for cellular data and set the default voice line.",
        faq5AnswerNote: "We suggest turning off your home number data roaming, but turning on Wi-Fi calling. This allows your home number to be accessible anywhere in the world via Wi-Fi or via your eSIM data.",
        faq6Question: "Should I turn on \"Data Roaming\" when using eSIM?",
        faq6Answer: "Yes, turn on data roaming for your eSIM and turn off roaming for your home SIM to avoid additional charges. Go to \"Settings\" > \"Cellular\" > \"Data Roaming\". <b>This is a requirement.</b>",
        faq7Question: "Can I use more than one eSIM provider when traveling abroad?",
        faq7Answer: "Yes, iPhones can store ~10 eSIMs, and Androids can store 5-7 eSIMs. Label eSIMs to avoid confusion.",
        faq8Question: "Can multiple phones scan the same QR code?",
        faq8Answer: "No, each QR code can be scanned by a unique device ID once, and cannot be transferred to another device later.",
        faq9Question: "Does my eSIM support hotspot, tethering or data sharing?",
        faq9Answer: "Yes. All of our eSIMs have enabled hotspot data sharing with other devices as permitted by the device manufacturer. On iOS, APNs are preconfigured except for Japan (set APN to \"vmobile.jp\"). For Android use the eSIM APN password to ensure connectivity. This information is available in the eSIM activation email.",
        faq10Question: "Can I request a refund?",
        faq10Answer: "Yes, refunds can be requested while the QR code has not been used or the service has not been activated.",
        faq10AnswerNote: "Processing fees are not refundable."
    },
    es: {
        // Common
        loading: "Cargando paquetes...",
        searchPlaceholder: "Buscar por nombres de pa\xedses",
        // Title Section
        logo: "I love J1",
        subtitle: "\xbfA d\xf3nde viajas?",
        subtitleDescription: "Agreg\xe1 los pa\xedses adonde viaj\xe1s para ver los planes que mejor se adaptan a tu viaje.",
        // Sections
        myEsims: "Mis eSIMs",
        availablePlans: "Planes Disponibles",
        favoritePlans: "Planes Favoritos",
        selectDuration: "Seleccionar Duraci\xf3n",
        selectDataPackage: "Seleccionar Paquete de Datos",
        esimFeatures: "Beneficios de una eSIM",
        faqTitle: "Preguntas Frecuentes",
        // eSIM Info
        esimInfoTitle: "\xbfQu\xe9 es una eSIM?",
        esimInfoText: "Una eSIM es una SIM digital que se instala en tu tel\xe9fono en segundos y te da acceso a un paquete de datos sin tener que cambiar chips ni hacer tr\xe1mites. Cuando lleg\xe1s al pa\xeds, se activa sola y te conecta a la red local sin cargos de roaming, para que puedas usar todas tus apps como siempre.",
        esimInfoNote: "Solo ten\xe9 en cuenta que no todos los tel\xe9fonos aceptan eSIM y que no vas a poder recibir o hacer llamadas tradicionales (por WhatsApp funciona perfecto).",
        // Features
        feature1Title: "Activaci\xf3n en 1 minuto",
        feature1Description: "Instal\xe1s la eSIM escaneando un c\xf3digo QR o tocando un bot\xf3n. No necesit\xe1s tr\xe1mites ni buscar puntos de venta.",
        feature2Title: "Conectado desde que aterriz\xe1s",
        feature2Description: "El plan se activa apenas lleg\xe1s al pa\xeds y ya ten\xe9s internet para ubicarte, comunicarte y moverte sin demora.",
        feature3Title: "No necesit\xe1s cambiar tu chip f\xedsico",
        feature3Description: "Pod\xe9s usar tu chip habitual y mantener tu n\xfamero de WhatsApp sin modificar nada en tu tel\xe9fono.",
        feature4Title: "Costos s\xfaper bajos",
        feature4Description: "Planes accesibles, sin contratos ni cargos ocultos. Pag\xe1s solo lo que necesit\xe1s durante tu viaje.",
        feature5Title: "Velocidad 5G donde est\xe9 disponible",
        feature5Description: "Conexi\xf3n r\xe1pida y estable para usar mapas, redes, videollamadas y cualquier app que necesites.",
        feature6Title: "Recargas instant\xe1neas",
        feature6Description: "Si se termina tu plan, lo renov\xe1s en segundos desde la web. Sin llamadas ni esperas.",
        // Cart
        cart: "Carrito",
        cartEmpty: "Tu carrito est\xe1 vac\xedo",
        clearCart: "Vaciar Carrito",
        total: "Total",
        buy: "Pagar",
        price: "Precio",
        processingFeeIncluded: "Cargo de Procesamiento (incluido)",
        quantity: "Cantidad",
        subtotal: "Subtotal",
        // Package Details
        packageDetails: "Detalles del Paquete",
        data: "Datos",
        dataUsage: "Uso de Datos",
        duration: "Duraci\xf3n",
        status: "Estado",
        speed: "Velocidad",
        sms: "SMS",
        dataType: "Tipo de Datos",
        activeType: "Tipo de Activaci\xf3n",
        operators: "Operadores",
        supportTopUp: "Permite Recargar",
        countriesIncluded: "Pa\xedses Incluidos",
        suspend: "Pausar",
        unsuspend: "Reactivar",
        topup: "Recargar",
        esimSuspended: "eSIM pausada exitosamente",
        esimUnsuspended: "eSIM activada exitosamente",
        suspendFailed: "La eSIM no permite ser pausada",
        unsuspendFailed: "La eSIM no permite ser activada",
        noTopupPlansAvailable: "No hay planes para recarga disponibles",
        topupPlans: "Planes para Recargar",
        errorLoadingTopupPlans: "Error al cargar los planes para recargar",
        packageCodeNotFound: "C\xf3digo del paquete no encontrado",
        storeNotAvailable: "Tienda no disponible",
        viewDetails: "Ver Detalles",
        // Navigation
        checkCompatibility: "Verificar Compatibilidad",
        installation: "Como Instalar",
        method1Title: "M\xe9todo 1: Escanear C\xf3digo QR o usa el bot\xf3n de instalaci\xf3n en iOS",
        method1Step1: "Escane\xe1 el c\xf3digo QR usando la c\xe1mara de tu tel\xe9fono.",
        method1Step2: 'Toc\xe1 "Plan Celular" para instalar.',
        roamingNotice: "Activ\xe1 el roaming para la eSIM. No te va a generar ning\xfan gasto adicional.",
        method2Title: "M\xe9todo 2: Ingresar C\xf3digo de Activaci\xf3n Manualmente",
        method2Step1: "And\xe1 a Configuraci\xf3n > Celular > Agregar eSIM > Ingresar Detalles Manualmente.",
        method2Step2: 'Ingres\xe1 la "Direcci\xf3n SM-DP+" y el "C\xf3digo de Activaci\xf3n", luego toc\xe1 "Siguiente".',
        deviceSearchPlaceholder: "Busca tu dispositivo",
        deviceCompatible: "Compatible",
        deviceNotCompatible: "No Compatible",
        deviceFound: "Dispositivo encontrado",
        deviceNotFound: "Dispositivo no encontrado",
        searchYourDevice: "Busca tu dispositivo para verificar la compatibilidad con eSIM",
        compatibilityMethod1Title: "M\xe9todo 1: Usar el c\xf3digo del teclado",
        compatibilityMethod1Step1: "Abr\xed el marcador de tu tel\xe9fono y escrib\xed *#06#.",
        compatibilityMethod1Step2: "Se mostrar\xe1 la pantalla con el IMEI de tu tel\xe9fono.",
        compatibilityMethod1Step3: 'Si tambi\xe9n muestra un "EID", tu tel\xe9fono es compatible con eSIM.',
        compatibilityMethod2Title: "M\xe9todo 2: Verificar en configuraci\xf3n",
        compatibilityMethod2Step1: "And\xe1 a la configuraci\xf3n de tu tel\xe9fono.",
        compatibilityMethod2Step2: "Para iOS: Configuraci\xf3n > Datos M\xf3viles/Celular",
        compatibilityMethod2Step3: "Para Android: Configuraci\xf3n > Conexiones/Administrador de tarjeta SIM",
        compatibilityMethod2Step4: 'Busc\xe1 si hay una opci\xf3n "Agregar eSIM" o "eSIM".',
        compatibilityMethod3Title: "M\xe9todo 3: Busc\xe1 en nuestra lista",
        // Auth
        account: "Cuenta",
        login: "Iniciar Sesi\xf3n",
        register: "Registrarse",
        logout: "Salir",
        emailAddress: "Direcci\xf3n de Correo",
        password: "Contrase\xf1a",
        firstName: "Nombre",
        lastName: "Apellido",
        fullName: "Nombre Completo",
        country: "Pa\xeds",
        language: "Idioma",
        spanish: "Espa\xf1ol",
        english: "Ingl\xe9s",
        passwordMinLength: "Debe tener al menos 6 caracteres",
        countryPlaceholder: "ej., Estados Unidos",
        hello: "Hola, {name}!",
        profile: "Perfil",
        editProfile: "Editar Perfil",
        saveChanges: "Guardar Cambios",
        allRightsReserved: "Todos los derechos reservados",
        needHelpContact: "Si necesitas ayuda, escribinos a",
        emailCopied: "Email copiado al portapapeles",
        newPassword: "Nueva Contrase\xf1a (opcional)",
        profileUpdated: "Perfil actualizado exitosamente!",
        profileUpdateFailed: "Error al actualizar el perfil. Por favor intenta de nuevo.",
        emailNotVerified: "Tu email no est\xe1 verificado. Aseg\xfarate que es el correcto y verif\xedcalo haciendo click en el link que te enviamos para no perder el acceso a la informaci\xf3n de tus eSIMs.",
        resendVerificationEmail: "Reenviar Email",
        verificationEmailResent: "\xa1Email de verificaci\xf3n enviado exitosamente!",
        verificationEmailResendFailed: "Error al reenviar el email de verificaci\xf3n. Por favor intenta de nuevo.",
        verificationCode: "C\xf3digo de Verificaci\xf3n",
        sendCode: "Enviar C\xf3digo",
        verifyCode: "Verificar C\xf3digo",
        codeSent: "\xa1C\xf3digo de verificaci\xf3n enviado exitosamente!",
        codeSentMessage: "Te enviamos un c\xf3digo a tu correo electr\xf3nico",
        emailDetailsMessage: "Te vamos a enviar los detalles de tu eSIM a este correo. Asegurate que sea el correcto.",
        codeSendFailed: "Error al enviar el c\xf3digo de verificaci\xf3n. Por favor intenta de nuevo.",
        codeVerificationFailed: "Error al verificar el c\xf3digo. Por favor verifica el c\xf3digo e intenta de nuevo.",
        codeVerified: "\xa1C\xf3digo verificado exitosamente!",
        invalidCode: "C\xf3digo inv\xe1lido. Por favor ingresa un c\xf3digo de 6 d\xedgitos.",
        nameRequired: "Necesitamos tu nombre completo.",
        emailRequired: "Necesitamos tu direcci\xf3n de correo.",
        changeEmail: "Cambiar email",
        // Messages
        emailVerified: "\xa1Correo verificado exitosamente!",
        emailVerificationFailed: "La verificaci\xf3n del correo fall\xf3. El enlace puede haber expirado.",
        loginSuccessful: "\xa1Inicio de sesi\xf3n exitoso!",
        loginFailed: "Error al iniciar sesi\xf3n. Por favor verifica tus credenciales.",
        passwordTooShort: "La contrase\xf1a debe tener al menos 6 caracteres",
        registrationSuccessful: "\xa1Registro exitoso!",
        registrationFailed: "Error en el registro. Por favor intenta de nuevo.",
        paymentCanceled: "Cancelaste el pago. Tu carrito se mantuvo.",
        paymentSuccessful: "\xa1Pago exitoso! Gracias por tu compra. Te enviamos un email con todos los detalles de tu compra.",
        errorProcessingPayment: "Error procesando el pago. Por favor intenta de nuevo.",
        termsAndConditions: "T\xe9rminos y Condiciones",
        pricesInUSD: "Precios en D\xf3lares Estadounidenses (USD)",
        noPlansFound: "No encontramos planes para los pa\xedses seleccionados",
        noEsims: "No encontramos eSIMs",
        loadingEsims: "Cargando tus eSIMs",
        usageUpdated: "Uso actualizado exitosamente",
        install: "Instalar",
        qr: "QR",
        iosInstall: "iOS <small>(17.4+)</small>",
        androidInstall: "Android <small>(10+)</small>",
        manual: "Manual",
        scanQrCode: "Escanealo con tu celular",
        smdpAddress: "SM-DP+ Address",
        activationCode: "C\xf3digo de Activaci\xf3n",
        apn: "APN",
        pin: "PIN",
        puk: "PUK",
        usageDelayNote: "con retraso de 1 hora",
        // Package info
        plan: "plan",
        plans: "planes",
        package: "paquete",
        packages: "paquetes",
        day: "d\xeda",
        days: "d\xedas",
        // Status
        included: "Incluido",
        notIncluded: "No incluido",
        yes: "S\xed",
        no: "No",
        // Data types
        dataInTotal: "Datos en Total",
        dailyLimitSpeedReduced: "L\xedmite Diario (Velocidad Reducida)",
        dailyLimitServiceCutoff: "L\xedmite Diario (Corte de Servicio)",
        dailyUnlimited: "Ilimitado Diario",
        // Active types
        firstInstallation: "Primera instalaci\xf3n",
        firstNetworkConnection: "Primera conexi\xf3n de red",
        // Autocomplete
        country: "Pa\xeds",
        region: "Regi\xf3n",
        global: "Global",
        // eSIM fields
        smdpStatus: "Estado SMDP",
        expiredTime: "Tiempo de Expiraci\xf3n",
        orderUsage: "Uso del Pedido",
        totalVolume: "Volumen Total",
        validity: "Validez",
        daysRemaining: "d\xedas restantes",
        dayRemaining: "d\xeda restante",
        // eSIM Status translations
        GETTING_RESOURCE: "Pendiente",
        GOT_RESOURCE: "Lista para Instalar",
        IN_USE: "En Uso",
        USED_UP: "Agotado",
        UNUSED_EXPIRED: "Vencido",
        USED_EXPIRED: "Vencido",
        CANCEL: "Cancelado",
        SUSPENDED: "Suspendido",
        REVOKE: "Cancelado",
        RELEASED: "Listo para Instalar",
        DOWNLOAD: "Descargado",
        INSTALLATION: "Instalada",
        ENABLED: "Habilitado",
        DISABLED: "Deshabilitado",
        DELETED: "Eliminado",
        // FAQ
        faqTitle: "Preguntas Frecuentes",
        faq1Question: "\xbfSe pueden recargar planes en la misma eSIM?",
        faq1Answer: "Los usuarios con un plan eSIM instalado y activo pueden realizar una recarga de datos para extender tanto la validez de la eSIM como la cantidad de datos. Los usuarios pueden recargar una eSIM un m\xe1ximo de 10 veces.",
        faq1AnswerExample: "Por ejemplo: si ten\xe9s un plan eSIM Europeo de 1GB por 7 d\xedas, podr\xedas agregar otra extensi\xf3n de 1GB por 7 d\xedas. Esta recarga se sumar\xeda al plan existente, haci\xe9ndolo 2GB por 14 d\xedas. ( 1GB + 1GB = 2GB total. 7 D\xedas + 7 D\xedas = 14 D\xedas total )",
        faq1AnswerNote: "Las recargas suman validez y datos para dar un nuevo total de validez y datos actualizado despu\xe9s de cada recarga.",
        faq2Question: "\xbfSe puede reinstalar una eSIM eliminada?",
        faq2Answer: "Las eSIMs PUEDEN reinstalarse desde el mismo c\xf3digo QR con el que se instalaron, en caso de que hayan sido eliminadas.",
        faq2AnswerNote: "Los usuarios pueden escanear el mismo c\xf3digo QR usado en la instalaci\xf3n inicial y volver a agregar el perfil eSIM en caso de eliminaci\xf3n de la eSIM. El proceso de reinstalaci\xf3n solo se puede hacer con el mismo dispositivo en el que se instal\xf3 originalmente.",
        faq2AnswerWarning: "Los c\xf3digos QR no se pueden compartir con otro dispositivo despu\xe9s de haber sido eliminados.",
        faq3Question: "\xbfCu\xe1ndo comienza el per\xedodo de activaci\xf3n o validez de un plan?",
        faq3Answer: 'Con la excepci\xf3n de algunos planes de datos, la mayor\xeda de los planes de datos solo comenzar\xe1n a contar el uso una vez que realices tu primera conexi\xf3n a la red local. Esto se indicar\xe1 como "Tipo de Activaci\xf3n: Primera conexi\xf3n de red".',
        faq3AnswerNote: 'Cuando muestra "Tipo de Activaci\xf3n: Primera instalaci\xf3n" el per\xedodo de facturaci\xf3n comenzar\xe1 inmediatamente despu\xe9s de la instalaci\xf3n y <u>activaci\xf3n</u> en tu dispositivo. Por lo tanto, te recomendamos activar el plan solo despu\xe9s de haber llegado a tu destino.',
        faq4Question: "\xbfMi eSIM viene con un n\xfamero de tel\xe9fono o SMS?",
        faq4Answer: "Generalmente, las eSIMs son solo de datos. Si una eSIM incluye un n\xfamero de tel\xe9fono o SMS, se detallar\xe1 en el plan. Si no se menciona minutos o SMS, es una eSIM solo de datos.",
        faq5Question: "\xbfPuedo usar una SIM f\xedsica y mi n\xfamero de casa y eSIM juntos?",
        faq5Answer: "S\xed, en dispositivos dual SIM, pod\xe9s usar tanto una SIM f\xedsica con tu n\xfamero de casa y una eSIM. Pod\xe9s seleccionar qu\xe9 SIM usar para datos celulares y establecer la l\xednea de voz predeterminada.",
        faq5AnswerNote: "Sugerimos desactivar el roaming de datos de tu n\xfamero de casa, pero activar las llamadas por Wi-Fi. Esto permite que tu n\xfamero de casa sea accesible en cualquier parte del mundo v\xeda Wi-Fi o v\xeda los datos de tu eSIM.",
        faq6Question: '\xbfDebo activar "Roaming de Datos" al usar eSIM?',
        faq6Answer: 'S\xed, activ\xe1 el roaming de datos para tu eSIM y desactiv\xe1 el roaming para tu SIM de casa para evitar cargos adicionales. And\xe1 a "Configuraci\xf3n" > "Celular" > "Roaming de Datos". <b>Esto es un requisito.</b>',
        faq7Question: "\xbfPuedo usar m\xe1s de un proveedor de eSIM cuando viajo al extranjero?",
        faq7Answer: "S\xed, los iPhones pueden almacenar ~10 eSIMs, y los Androids pueden almacenar 5-7 eSIMs. Etiquet\xe1 las eSIMs para evitar confusi\xf3n.",
        faq8Question: "\xbfPueden varios tel\xe9fonos escanear el mismo c\xf3digo QR?",
        faq8Answer: "No, cada c\xf3digo QR puede ser escaneado por un ID de dispositivo \xfanico una vez, y no se puede transferir a otro dispositivo despu\xe9s.",
        faq9Question: "\xbfMi eSIM admite hotspot, anclaje a red o compartir datos?",
        faq9Answer: 'S\xed. Todas nuestras eSIMs tienen habilitado el compartir datos de hotspot con otros dispositivos seg\xfan lo permitido por el fabricante del dispositivo. En iOS, los APN est\xe1n preconfigurados excepto para Jap\xf3n (configur\xe1 el APN como "vmobile.jp"). Para Android us\xe1 la contrase\xf1a APN de la eSIM para asegurar la conectividad. Esta informaci\xf3n est\xe1 disponible en el email de activaci\xf3n de la eSIM.',
        faq10Question: "\xbfSe pueden solicitar un reembolso?",
        faq10Answer: "S\xed, se pueden solicitar reembolsos mientras el c\xf3digo QR no haya sido utilizado o el servicio no haya sido activado.",
        faq10AnswerNote: "Los cargos de procesamiento no son reembolsables."
    }
};

});


parcelRegister("gGcib", function(module, exports) {

$parcel$export(module.exports, "hideDropdown", () => $c24a1a98a21ce8e1$export$d4646ca64682bd64);
$parcel$export(module.exports, "formatVolume", () => $c24a1a98a21ce8e1$export$e707b726ec359642);
$parcel$export(module.exports, "normalizeText", () => $c24a1a98a21ce8e1$export$7c2714a5250b9239);
$parcel$export(module.exports, "translateDayText", () => $c24a1a98a21ce8e1$export$fbf15e4106db559d);
$parcel$export(module.exports, "adjustBodyBackgroundSize", () => $c24a1a98a21ce8e1$export$499541de0112a064);
/**
 * Hides dropdown element
 * @param {HTMLElement|null} dropdownElement - Dropdown DOM element
 */ 
var $7xovm = parcelRequire("7xovm");
function $c24a1a98a21ce8e1$export$d4646ca64682bd64(dropdownElement) {
    if (dropdownElement) dropdownElement.classList.add('hidden');
}
function $c24a1a98a21ce8e1$export$e707b726ec359642(volumeBytes) {
    const volumeGB = volumeBytes / 1073741824;
    return volumeGB < 1 ? `${(volumeGB * 1024).toFixed(0)} MB` : `${volumeGB.toFixed(1)} GB`;
}
function $c24a1a98a21ce8e1$export$3ae94a2503e890a1(dateString) {
    if (!dateString || dateString === '-') return '-';
    try {
        const date = new Date(dateString);
        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    } catch (e) {
        return dateString;
    }
}
function $c24a1a98a21ce8e1$export$7c2714a5250b9239(text) {
    return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s]/g, '');
}
function $c24a1a98a21ce8e1$export$fbf15e4106db559d(text, count = null) {
    if (!text) return text;
    const isSpanish = (0, $7xovm.default).getLanguage() === 'es';
    const isPlural = count !== null ? count > 1 : /\bDays\b/i.test(text);
    text = text.replace(/(\S)(Day|Days)\b/gi, '$1 $2');
    if (isSpanish) {
        if (isPlural) text = text.replace(/\bDays\b/gi, "D\xedas").replace(/\bDay\b/gi, "D\xedas");
        else text = text.replace(/\bDays\b/gi, "D\xedas").replace(/\bDay\b/gi, "D\xedas");
    } else if (isPlural) text = text.replace(/\bDay\b(?!s\b)/gi, 'Days');
    return text;
}
function $c24a1a98a21ce8e1$export$499541de0112a064() {
    const body = document.body;
    const backgroundImage = getComputedStyle(body).backgroundImage;
    // Extraer la URL de la imagen (remover "url(" y ")" o "url('...')")
    const urlMatch = backgroundImage.match(/url\(['"]?([^'"]+)['"]?\)/);
    if (!urlMatch || !urlMatch[1]) {
        console.warn("No se encontr\xf3 imagen de fondo en el body");
        return;
    }
    const imageUrl = urlMatch[1];
    // Crear una imagen para obtener sus dimensiones naturales
    const img = new Image();
    img.onload = function() {
        const viewportWidth = window.innerWidth;
        const targetHeight = 500; // Altura objetivo de 400px
        // Calcular la relación de aspecto de la imagen
        const imageAspectRatio = img.width / img.height;
        // Calcular la altura que tendría la imagen con 100% de ancho
        const heightAt100PercentWidth = viewportWidth / imageAspectRatio;
        let currentHeight;
        // Si con 100% de ancho la altura es menor a 400px, necesitamos agrandar
        if (heightAt100PercentWidth < targetHeight) {
            // Calcular el ancho necesario para alcanzar 400px de altura
            const requiredWidth = targetHeight * imageAspectRatio;
            const widthPercentage = requiredWidth / viewportWidth * 100;
            body.style.backgroundSize = `${widthPercentage}% auto`;
            currentHeight = targetHeight; // La altura será 400px
        } else {
            // Si con 100% de ancho ya alcanza o supera 400px de altura, usar 100% auto
            body.style.backgroundSize = '100% auto';
            currentHeight = heightAt100PercentWidth; // La altura será la calculada
        }
        // Obtener la altura del top-menu y restarla del currentHeight
        const topMenu = document.querySelector('.top-menu');
        let topMenuHeight = 0;
        if (topMenu) topMenuHeight = topMenu.offsetHeight;
        // Calcular la altura final restando la altura del menu
        const finalHeight = Math.max(0, Math.round(currentHeight) - topMenuHeight);
        // Establecer una variable CSS para usar en el CSS
        body.style.setProperty('--image-height', `${finalHeight}px`);
    };
    img.onerror = function() {
        console.warn('No se pudo cargar la imagen de fondo para calcular dimensiones');
        // Fallback al tamaño original si hay error
        body.style.backgroundSize = '100% auto';
    };
    img.src = imageUrl;
}

});


//# sourceMappingURL=terms.4f99b699.js.map
